import { client } from "../../infrastructure/graphql/client";
import {
  GET_ALL_SCHEDULES,
  UPDATE_SCHEDULER,
  SYNC_INFRASTRUCTURE,
  SYNC_PERFORMANCE,
  SYNC_ALERTS,
  SYNC_INVOICES,
  SYNC_MONTHLY_COSTS,
  SYNC_BACKUP,
} from "../../infrastructure/graphql/schedulerQuerries";

export class SchedulerService {
  async getAllSchedules() {
    try {
      const result = await client.query({
        query: GET_ALL_SCHEDULES,
        fetchPolicy: "network-only",
      });

      const response = result.data?.getAllSchedules;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          schedules: null,
        };
      }

      return {
        success: true,
        schedules: response,
      };
    } catch (error) {
      console.error("Get all schedules error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, schedules: null };
    }
  }

  async updateScheduler(task, cronExpression) {
    try {
      const result = await client.mutate({
        mutation: UPDATE_SCHEDULER,
        variables: { task, cronExpression },
      });
      const response = result.data?.updateScheduler;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      if (response.startsWith("Successfully updated")) {
        return { success: true, message: response, data: response };
      } else if (response.startsWith("Unknown task")) {
        return { success: false, message: response, data: null };
      }
      return { success: true, message: response, data: response };
    } catch (error) {
      console.error("Update scheduler error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async syncInfrastructure() {
    try {
      const result = await client.mutate({
        mutation: SYNC_INFRASTRUCTURE,
      });
      const response = result.data?.syncAzureInfrastructure;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, message: response, data: response };
    } catch (error) {
      console.error("Sync infrastructure error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async syncPerformance() {
    try {
      const result = await client.mutate({
        mutation: SYNC_PERFORMANCE,
      });
      const response = result.data?.triggerMetricsSync;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, message: response, data: response };
    } catch (error) {
      console.error("Sync performance error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async syncAlerts() {
    try {
      const result = await client.mutate({
        mutation: SYNC_ALERTS,
      });
      const response = result.data?.triggerAlertSync;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, message: response, data: response };
    } catch (error) {
      console.error("Sync alerts error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async syncInvoices() {
    try {
      const result = await client.mutate({
        mutation: SYNC_INVOICES,
      });
      const response = result.data?.savePreviousMonthInvoice;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, message: response, data: response };
    } catch (error) {
      console.error("Sync invoices error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async syncMonthlyCosts(year, month) {
    try {
      const result = await client.mutate({
        mutation: SYNC_MONTHLY_COSTS,
        variables: { year, month },
      });
      const response = result.data?.syncMonthlyCosts;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, message: response, data: response };
    } catch (error) {
      console.error("Sync monthly costs error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async syncBackup() {
    try {
      const result = await client.mutate({
        mutation: SYNC_BACKUP,
      });
      const response = result.data?.syncBackupData;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, message: response, data: response };
    } catch (error) {
      console.error("Sync backup error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}